import { render } from "./VolunteerUser.view.vue?vue&type=template&id=4669a11a"
import script from "./VolunteerUser.view.vue?vue&type=script&lang=js"
export * from "./VolunteerUser.view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__